/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React from 'react'
export default function TextArea(
    {type,
        state,
        id,
        handleInput,
        submitSelected,
        setsubmitSelected,
        className,
        text,
        maxLength,
        customError,
        optional,
        wordsLength,
        placeholder}) {
    return (
        <>
            <textarea 
                type={type||"text"}
                id={id}
                autoComplete="new-password"
                maxLength={maxLength ? maxLength : '100'}
                value={state[id]}
                onChange={(e)=>handleInput(e)}
                onFocus={()=>setsubmitSelected(false)}
                redBorder={(submitSelected&& state[id] === ''&&optional===undefined || (wordsLength !== undefined && wordsLength)  )}
                className={`txt-fld w-full`}
                placeholder={placeholder} />
            {(submitSelected&&state[id] === '' && optional===undefined || (submitSelected &&customError!==undefined && state[id]==="-"))&&
                <p className="text-f1 font-normal text-[#F04438] add-error2 pt-1.5">{text}</p>}</>

    )
}